var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.bannerSelector(_vm.CAT))?_vm._t("cat"):_vm._e(),(_vm.bannerSelector(_vm.DOG))?_vm._t("dog"):_vm._e(),(_vm.bannerSelector(_vm.MIX))?_vm._t("mix"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }